import isMailSpokeScreenOpen from 'mini-mail-compose-store/lib/utils/isMailSpokeScreenOpen';

/**
 * This utility checks for whether A2HS can be shown if it is in Mail Surface
 * NOTE - This is just a partial check and does not guarantee that A2HS banner will be shown
 */
export const canA2HSCustomBannerBeShownInMail = () => {
    let canBannerBeShown: boolean;
    if (isMailSpokeScreenOpen()) {
        canBannerBeShown = false;
    } else {
        canBannerBeShown = true;
    }

    //Currently blocking A2HS banner, to ensure that push towards Native apps is not impacted.
    //This will later be restarted with different conditions.
    canBannerBeShown = false;
    return canBannerBeShown;
};
